import { updateKeyInStore } from 'App';
import { LogisticsStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof LogisticsStateValues>[] = [
  {
    type: 'upload',
    name: 'residentCountryTaxCopy',
    label:
      'Please upload a copy of the RESIDENT COUNTRY tax declaration (tax return) and if available, the official Income Tax Assessment form for the filing year.',

    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.logistics.values.annualTaxSummaryOutsideUs',
  },
  {
    type: 'upload',
    name: 'checkCopy',
    label: 'Upload Check',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'Upload Void Check',
    dependentOn:
      'taxQuestionnaire.personal_details.the_basics.logistics.values.uploadCheckOrManuallyWriteBank',
  },
];
